var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDeaccess && _vm.isInfected)?_c('div',[_c('v-textarea',{attrs:{"label":"Infection Notes"},model:{value:(_vm.infectionNotes),callback:function ($$v) {_vm.infectionNotes=$$v},expression:"infectionNotes"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }